import { gql } from 'graphql-request';
import { ProjectFile } from 'src/shared/types/graph/project';

// Query dedicated to fetching site files without going through projectDefinition
export const siteFilesQuery = gql`
    query getProjectFiles($projectId: String!) {
        getProjectSummary(projectId: $projectId) {
            files {
                id
                relatedTo
                size
                name
                awsFileKey
                fileType
                createdAt
                creatorName
            }
        }
    }
`;

export type SiteFilesQueryResult = {
    getProjectSummary: {
        files: ProjectFile[];
    };
};
